var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimesheetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Timesheet_Icon",
    "data-name": "Timesheet Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M10.069,14.993H9.723a.742.742,0,1,1,0-1.485h.347a7.326,7.326,0,0,0,5.277-2.257.743.743,0,0,1,1.049-.024.744.744,0,0,1,.024,1.049A8.82,8.82,0,0,1,10.069,14.993Zm-3.352,0H4.453A4.459,4.459,0,0,1,0,10.539V4.454A4.459,4.459,0,0,1,4.453,0H14.547A4.459,4.459,0,0,1,19,4.454V6.68a.742.742,0,1,1-1.484,0V4.454a2.972,2.972,0,0,0-2.969-2.969H4.453A2.972,2.972,0,0,0,1.484,4.454v6.085a2.972,2.972,0,0,0,2.969,2.969H6.717a.742.742,0,1,1,0,1.485Zm11.541-1.522a.743.743,0,0,1-.742-.743V10.769a.787.787,0,0,0-.786-.787H14.77a.743.743,0,1,1,0-1.485h1.96A2.273,2.273,0,0,1,19,10.769v1.959A.743.743,0,0,1,18.257,13.471Zm-10.2-1.744A.927.927,0,1,1,8.98,10.8.929.929,0,0,1,8.053,11.727Zm-3.191,0a.927.927,0,1,1,.927-.928A.929.929,0,0,1,4.862,11.727Zm6.383-3.191a.928.928,0,1,1,.927-.928A.929.929,0,0,1,11.245,8.536Zm-3.191,0a.928.928,0,1,1,.927-.928A.929.929,0,0,1,8.053,8.536Zm-3.191,0a.928.928,0,1,1,.927-.928A.929.929,0,0,1,4.862,8.536Zm6.383-3.191a.927.927,0,1,1,.927-.928A.929.929,0,0,1,11.245,5.344Zm-3.191,0a.927.927,0,1,1,.927-.928A.929.929,0,0,1,8.053,5.344Zm-3.191,0a.927.927,0,1,1,.927-.928A.929.929,0,0,1,4.862,5.344Z",
    transform: "translate(0 4.007)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M11.392,9.351a.927.927,0,1,1,.928-.928A.928.928,0,0,1,11.392,9.351Zm.854-6.383a.743.743,0,0,1-.743-.743.742.742,0,0,0-1.484,0,.742.742,0,1,1-1.484,0,2.226,2.226,0,0,1,4.452,0A.743.743,0,0,1,12.246,2.968Zm-8.536,0a.743.743,0,0,1-.742-.743.743.743,0,0,0-1.485,0A.742.742,0,1,1,0,2.226a2.227,2.227,0,0,1,4.453,0A.743.743,0,0,1,3.711,2.968Z",
    transform: "translate(3.043 0)",
    fill: "#eb742e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesheetIcon);
export default __webpack_public_path__ + "static/media/Timesheet-Icon.a19872b04eecc4166af076080bb3078a.svg";
export { ForwardRef as ReactComponent };